import ApiBase from './base/ApiBase'

class EmployeeClient extends ApiBase
{
    private controllerName: string = 'Employee';

    async GetEmployeeDetail(systemUserId: string, signal?: AbortSignal) : Promise<EmployeeDetail>
    {
        return this.GetAsync(`${this.controllerName}/${systemUserId}`, signal);
    }

    async AddRole(systemUserId: string, role: string, signal?: AbortSignal) : Promise<string[]>
    {
        return this.PutAsync(`${this.controllerName}/${systemUserId}/Role?role=${role}`, null, signal);
    }

    async RemoveRole(systemUserId: string, role: string, signal?: AbortSignal) : Promise<string[]>
    {
        return this.DeleteAsync(`${this.controllerName}/${systemUserId}/Role?role=${role}`, signal);
    }
}

export interface EmployeeDetail 
{
    EmailAddressLowered: string;
    FirstName: string;
    LastName: string;
    Roles: string[];
}

export default EmployeeClient;